/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateExploreFromWarehouseTableMutationVariables = Types.Exact<{
  dataSourceTableId: Types.Scalars["DataSourceTableId"]["input"];
}>;

export type CreateExploreFromWarehouseTableMutation = {
  readonly __typename: "Mutation";
  readonly createExploreFromData: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
  };
};

export type CreateExploreFromSemanticDatasetMutationVariables = Types.Exact<{
  semanticDatasetId: Types.Scalars["SemanticDatasetId"]["input"];
  semanticProjectVersionString: Types.InputMaybe<
    Types.Scalars["SemanticProjectVersionString"]["input"]
  >;
  initialMeasureName: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  initialDimensionName: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type CreateExploreFromSemanticDatasetMutation = {
  readonly __typename: "Mutation";
  readonly createExploreFromData: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
  };
};

export type CreateExploreFromSemanticViewMutationVariables = Types.Exact<{
  semanticViewId: Types.Scalars["SemanticViewId"]["input"];
  semanticProjectVersionString: Types.InputMaybe<
    Types.Scalars["SemanticProjectVersionString"]["input"]
  >;
  initialMeasureName: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  initialDimensionName: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type CreateExploreFromSemanticViewMutation = {
  readonly __typename: "Mutation";
  readonly createExploreFromData: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
  };
};

export type CreateExploreFromMagicMutationVariables = Types.Exact<{
  dataConnectionId: Types.InputMaybe<
    Types.Scalars["DataConnectionId"]["input"]
  >;
  prompt: Types.Scalars["RichTextDocument"]["input"];
  mentionedTableIds:
    | ReadonlyArray<Types.Scalars["DataSourceTableId"]["input"]>
    | Types.Scalars["DataSourceTableId"]["input"];
  timezone: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  semanticProjectId: Types.InputMaybe<
    Types.Scalars["SemanticProjectId"]["input"]
  >;
}>;

export type CreateExploreFromMagicMutation = {
  readonly __typename: "Mutation";
  readonly createExploreFromMagic: {
    readonly __typename: "CreateExploreFromMagicResult";
    readonly hex: {
      readonly __typename: "Hex";
      readonly id: c.HexId;
      readonly currentDraft: {
        readonly __typename: "HexVersion";
        readonly id: c.HexVersionId;
        readonly logicSessionId: c.AppSessionId;
      };
    };
    readonly magicEvent: {
      readonly __typename: "MagicEvent";
      readonly id: c.MagicEventId;
    };
  };
};

export type CreateExploreFromSuggestedPromptMutationVariables = Types.Exact<{
  magicSuggestedPromptId: Types.Scalars["MagicSuggestedPromptId"]["input"];
  timezone: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type CreateExploreFromSuggestedPromptMutation = {
  readonly __typename: "Mutation";
  readonly generateExploreFromSuggestedPrompt: {
    readonly __typename: "CreateExploreFromMagicResult";
    readonly magicEvent: {
      readonly __typename: "MagicEvent";
      readonly id: c.MagicEventId;
    };
    readonly hex: {
      readonly __typename: "Hex";
      readonly id: c.HexId;
      readonly currentDraft: {
        readonly __typename: "HexVersion";
        readonly id: c.HexVersionId;
      };
    };
  };
};

export const CreateExploreFromWarehouseTableDocument = /*#__PURE__*/ gql`
  mutation CreateExploreFromWarehouseTable(
    $dataSourceTableId: DataSourceTableId!
  ) {
    createExploreFromData(dataSourceTableId: $dataSourceTableId) {
      id
    }
  }
`;
export type CreateExploreFromWarehouseTableMutationFn = Apollo.MutationFunction<
  CreateExploreFromWarehouseTableMutation,
  CreateExploreFromWarehouseTableMutationVariables
>;

/**
 * __useCreateExploreFromWarehouseTableMutation__
 *
 * To run a mutation, you first call `useCreateExploreFromWarehouseTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExploreFromWarehouseTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExploreFromWarehouseTableMutation, { data, loading, error }] = useCreateExploreFromWarehouseTableMutation({
 *   variables: {
 *      dataSourceTableId: // value for 'dataSourceTableId'
 *   },
 * });
 */
export function useCreateExploreFromWarehouseTableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateExploreFromWarehouseTableMutation,
    CreateExploreFromWarehouseTableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateExploreFromWarehouseTableMutation,
    CreateExploreFromWarehouseTableMutationVariables
  >(CreateExploreFromWarehouseTableDocument, options);
}
export type CreateExploreFromWarehouseTableMutationHookResult = ReturnType<
  typeof useCreateExploreFromWarehouseTableMutation
>;
export type CreateExploreFromWarehouseTableMutationResult =
  Apollo.MutationResult<CreateExploreFromWarehouseTableMutation>;
export type CreateExploreFromWarehouseTableMutationOptions =
  Apollo.BaseMutationOptions<
    CreateExploreFromWarehouseTableMutation,
    CreateExploreFromWarehouseTableMutationVariables
  >;
export const CreateExploreFromSemanticDatasetDocument = /*#__PURE__*/ gql`
  mutation CreateExploreFromSemanticDataset(
    $semanticDatasetId: SemanticDatasetId!
    $semanticProjectVersionString: SemanticProjectVersionString
    $initialMeasureName: String
    $initialDimensionName: String
  ) {
    createExploreFromData(
      semanticDatasetId: $semanticDatasetId
      semanticProjectVersionString: $semanticProjectVersionString
      initialMeasureName: $initialMeasureName
      initialDimensionName: $initialDimensionName
    ) {
      id
    }
  }
`;
export type CreateExploreFromSemanticDatasetMutationFn =
  Apollo.MutationFunction<
    CreateExploreFromSemanticDatasetMutation,
    CreateExploreFromSemanticDatasetMutationVariables
  >;

/**
 * __useCreateExploreFromSemanticDatasetMutation__
 *
 * To run a mutation, you first call `useCreateExploreFromSemanticDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExploreFromSemanticDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExploreFromSemanticDatasetMutation, { data, loading, error }] = useCreateExploreFromSemanticDatasetMutation({
 *   variables: {
 *      semanticDatasetId: // value for 'semanticDatasetId'
 *      semanticProjectVersionString: // value for 'semanticProjectVersionString'
 *      initialMeasureName: // value for 'initialMeasureName'
 *      initialDimensionName: // value for 'initialDimensionName'
 *   },
 * });
 */
export function useCreateExploreFromSemanticDatasetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateExploreFromSemanticDatasetMutation,
    CreateExploreFromSemanticDatasetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateExploreFromSemanticDatasetMutation,
    CreateExploreFromSemanticDatasetMutationVariables
  >(CreateExploreFromSemanticDatasetDocument, options);
}
export type CreateExploreFromSemanticDatasetMutationHookResult = ReturnType<
  typeof useCreateExploreFromSemanticDatasetMutation
>;
export type CreateExploreFromSemanticDatasetMutationResult =
  Apollo.MutationResult<CreateExploreFromSemanticDatasetMutation>;
export type CreateExploreFromSemanticDatasetMutationOptions =
  Apollo.BaseMutationOptions<
    CreateExploreFromSemanticDatasetMutation,
    CreateExploreFromSemanticDatasetMutationVariables
  >;
export const CreateExploreFromSemanticViewDocument = /*#__PURE__*/ gql`
  mutation CreateExploreFromSemanticView(
    $semanticViewId: SemanticViewId!
    $semanticProjectVersionString: SemanticProjectVersionString
    $initialMeasureName: String
    $initialDimensionName: String
  ) {
    createExploreFromData(
      semanticViewId: $semanticViewId
      semanticProjectVersionString: $semanticProjectVersionString
      initialMeasureName: $initialMeasureName
      initialDimensionName: $initialDimensionName
    ) {
      id
    }
  }
`;
export type CreateExploreFromSemanticViewMutationFn = Apollo.MutationFunction<
  CreateExploreFromSemanticViewMutation,
  CreateExploreFromSemanticViewMutationVariables
>;

/**
 * __useCreateExploreFromSemanticViewMutation__
 *
 * To run a mutation, you first call `useCreateExploreFromSemanticViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExploreFromSemanticViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExploreFromSemanticViewMutation, { data, loading, error }] = useCreateExploreFromSemanticViewMutation({
 *   variables: {
 *      semanticViewId: // value for 'semanticViewId'
 *      semanticProjectVersionString: // value for 'semanticProjectVersionString'
 *      initialMeasureName: // value for 'initialMeasureName'
 *      initialDimensionName: // value for 'initialDimensionName'
 *   },
 * });
 */
export function useCreateExploreFromSemanticViewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateExploreFromSemanticViewMutation,
    CreateExploreFromSemanticViewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateExploreFromSemanticViewMutation,
    CreateExploreFromSemanticViewMutationVariables
  >(CreateExploreFromSemanticViewDocument, options);
}
export type CreateExploreFromSemanticViewMutationHookResult = ReturnType<
  typeof useCreateExploreFromSemanticViewMutation
>;
export type CreateExploreFromSemanticViewMutationResult =
  Apollo.MutationResult<CreateExploreFromSemanticViewMutation>;
export type CreateExploreFromSemanticViewMutationOptions =
  Apollo.BaseMutationOptions<
    CreateExploreFromSemanticViewMutation,
    CreateExploreFromSemanticViewMutationVariables
  >;
export const CreateExploreFromMagicDocument = /*#__PURE__*/ gql`
  mutation CreateExploreFromMagic(
    $dataConnectionId: DataConnectionId
    $prompt: RichTextDocument!
    $mentionedTableIds: [DataSourceTableId!]!
    $timezone: String
    $semanticProjectId: SemanticProjectId
  ) {
    createExploreFromMagic(
      dataConnectionId: $dataConnectionId
      prompt: $prompt
      mentionedTableIds: $mentionedTableIds
      timezone: $timezone
      semanticProjectId: $semanticProjectId
    ) {
      hex {
        id
        currentDraft {
          id
          logicSessionId
        }
      }
      magicEvent {
        id
      }
    }
  }
`;
export type CreateExploreFromMagicMutationFn = Apollo.MutationFunction<
  CreateExploreFromMagicMutation,
  CreateExploreFromMagicMutationVariables
>;

/**
 * __useCreateExploreFromMagicMutation__
 *
 * To run a mutation, you first call `useCreateExploreFromMagicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExploreFromMagicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExploreFromMagicMutation, { data, loading, error }] = useCreateExploreFromMagicMutation({
 *   variables: {
 *      dataConnectionId: // value for 'dataConnectionId'
 *      prompt: // value for 'prompt'
 *      mentionedTableIds: // value for 'mentionedTableIds'
 *      timezone: // value for 'timezone'
 *      semanticProjectId: // value for 'semanticProjectId'
 *   },
 * });
 */
export function useCreateExploreFromMagicMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateExploreFromMagicMutation,
    CreateExploreFromMagicMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateExploreFromMagicMutation,
    CreateExploreFromMagicMutationVariables
  >(CreateExploreFromMagicDocument, options);
}
export type CreateExploreFromMagicMutationHookResult = ReturnType<
  typeof useCreateExploreFromMagicMutation
>;
export type CreateExploreFromMagicMutationResult =
  Apollo.MutationResult<CreateExploreFromMagicMutation>;
export type CreateExploreFromMagicMutationOptions = Apollo.BaseMutationOptions<
  CreateExploreFromMagicMutation,
  CreateExploreFromMagicMutationVariables
>;
export const CreateExploreFromSuggestedPromptDocument = /*#__PURE__*/ gql`
  mutation CreateExploreFromSuggestedPrompt(
    $magicSuggestedPromptId: MagicSuggestedPromptId!
    $timezone: String
  ) {
    generateExploreFromSuggestedPrompt(
      magicSuggestedPromptId: $magicSuggestedPromptId
      timezone: $timezone
    ) {
      magicEvent {
        id
      }
      hex {
        id
        currentDraft {
          id
        }
      }
    }
  }
`;
export type CreateExploreFromSuggestedPromptMutationFn =
  Apollo.MutationFunction<
    CreateExploreFromSuggestedPromptMutation,
    CreateExploreFromSuggestedPromptMutationVariables
  >;

/**
 * __useCreateExploreFromSuggestedPromptMutation__
 *
 * To run a mutation, you first call `useCreateExploreFromSuggestedPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExploreFromSuggestedPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExploreFromSuggestedPromptMutation, { data, loading, error }] = useCreateExploreFromSuggestedPromptMutation({
 *   variables: {
 *      magicSuggestedPromptId: // value for 'magicSuggestedPromptId'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useCreateExploreFromSuggestedPromptMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateExploreFromSuggestedPromptMutation,
    CreateExploreFromSuggestedPromptMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateExploreFromSuggestedPromptMutation,
    CreateExploreFromSuggestedPromptMutationVariables
  >(CreateExploreFromSuggestedPromptDocument, options);
}
export type CreateExploreFromSuggestedPromptMutationHookResult = ReturnType<
  typeof useCreateExploreFromSuggestedPromptMutation
>;
export type CreateExploreFromSuggestedPromptMutationResult =
  Apollo.MutationResult<CreateExploreFromSuggestedPromptMutation>;
export type CreateExploreFromSuggestedPromptMutationOptions =
  Apollo.BaseMutationOptions<
    CreateExploreFromSuggestedPromptMutation,
    CreateExploreFromSuggestedPromptMutationVariables
  >;
